import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SearchComponent } from '@shared/components/search/search.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-search',
	imports: [SharedModule, SearchComponent, UiCodeBlockComponent],
	templateUrl: './ui-search.component.html',
	styleUrl: './ui-search.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiSearchComponent {
	@Input() searchControl!: FormControl;
	@Input() disabledSearchControl!: FormControl;
	@Input() errorSearchControl!: FormControl;
	@Input() multiselectSearchControl!: FormControl;

	// Sample suggestions for examples - values equal to labels
	countrySuggestions = [
		{ label: 'Afghanistan', value: 'Afghanistan' },
		{ label: 'Albania', value: 'Albania' },
		{ label: 'Algeria', value: 'Algeria' },
		{ label: 'Argentina', value: 'Argentina' },
		{ label: 'Australia', value: 'Australia' },
		{ label: 'Austria', value: 'Austria' },
		{ label: 'Belgium', value: 'Belgium' },
		{ label: 'Brazil', value: 'Brazil' },
		{ label: 'Canada', value: 'Canada' },
		{ label: 'Chile', value: 'Chile' },
		{ label: 'China', value: 'China' },
		{ label: 'Colombia', value: 'Colombia' },
		{ label: 'Croatia', value: 'Croatia' },
		{ label: 'Cuba', value: 'Cuba' },
		{ label: 'Czech Republic', value: 'Czech Republic' },
		{ label: 'Denmark', value: 'Denmark' },
		{ label: 'Ecuador', value: 'Ecuador' },
		{ label: 'Egypt', value: 'Egypt' },
		{ label: 'Finland', value: 'Finland' },
		{ label: 'France', value: 'France' },
		{ label: 'Germany', value: 'Germany' },
		{ label: 'Greece', value: 'Greece' },
		{ label: 'Hungary', value: 'Hungary' },
		{ label: 'Iceland', value: 'Iceland' },
		{ label: 'India', value: 'India' },
		{ label: 'Indonesia', value: 'Indonesia' },
		{ label: 'Iran', value: 'Iran' },
		{ label: 'Iraq', value: 'Iraq' },
		{ label: 'Ireland', value: 'Ireland' },
		{ label: 'Italy', value: 'Italy' },
		{ label: 'Japan', value: 'Japan' },
		{ label: 'Mexico', value: 'Mexico' },
		{ label: 'Netherlands', value: 'Netherlands' },
		{ label: 'New Zealand', value: 'New Zealand' },
		{ label: 'Norway', value: 'Norway' },
		{ label: 'Peru', value: 'Peru' },
		{ label: 'Poland', value: 'Poland' },
		{ label: 'Portugal', value: 'Portugal' },
		{ label: 'Romania', value: 'Romania' },
		{ label: 'Russia', value: 'Russia' },
		{ label: 'South Africa', value: 'South Africa' },
		{ label: 'South Korea', value: 'South Korea' },
		{ label: 'Spain', value: 'Spain' },
		{ label: 'Sweden', value: 'Sweden' },
		{ label: 'Switzerland', value: 'Switzerland' },
		{ label: 'Thailand', value: 'Thailand' },
		{ label: 'Turkey', value: 'Turkey' },
		{ label: 'Ukraine', value: 'Ukraine' },
		{ label: 'United Kingdom', value: 'United Kingdom' },
		{ label: 'United States', value: 'United States' },
		{ label: 'Uruguay', value: 'Uruguay' },
		{ label: 'Venezuela', value: 'Venezuela' },
		{ label: 'Vietnam', value: 'Vietnam' },
	];

	generateCode(attrs: {
		formControl?: string;
		suggestions?: string;
		placeholder?: string;
		label?: string;
		size?: string;
		disabled?: boolean;
		error?: boolean;
		errorMessage?: string;
		multiple?: boolean;
	}): string {
		let code = '';

		// If disabled, show how to create FormControl with disabled state
		if (attrs.disabled && attrs.formControl) {
			code += `// Create FormControl with disabled state:\n`;
			code += `${attrs.formControl} = new FormControl({ value: '', disabled: true });\n\n`;
		}

		code += '<app-search';

		if (attrs.formControl) code += `\n    [formControl]="${attrs.formControl}"`;
		if (attrs.suggestions) code += `\n    [suggestions]="${attrs.suggestions}"`;
		if (attrs.placeholder) code += `\n    placeholder="${attrs.placeholder}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		// Don't include [disabled] in template when using FormControl
		if (attrs.error) code += `\n    [error]="true"`;
		if (attrs.errorMessage) code += `\n    errorMessage="${attrs.errorMessage}"`;
		if (attrs.multiple) code += `\n    [multiple]="true"`;

		code += '\n/>';
		return code;
	}
}
